// extracted by mini-css-extract-plugin
export default {"moreList":"index_moreList_rI67C","ulList":"index_ulList_0pOkA"};